import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material';
import axios from "axios";
import { Mensaje } from '../../mensajes2';
import { Dimmer } from "../../spinner";
import { validaSoloNumero, cmes, validaMonto, formatoMonto } from '../../../util/varios';
import moment from 'moment';
import CatalogoContable from '../../../catalogos/catalogoContable';

const ImpModalCaja = props => {
    let op = require('../../../modulos/datos');
    let token = localStorage.getItem("jwtToken");
    const [esDolar, setEsDolar] = useState(false);
    const valorDolar = JSON.parse(localStorage.getItem('valorDolar'))
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const idorganizacion = JSON.parse(localStorage.getItem('idorganizacion'));
    const fechasistema = JSON.parse(localStorage.getItem('fechasistema'));
    const riforg = JSON.parse(localStorage.getItem('riforg'));
    const efiscalanio = JSON.parse(localStorage.getItem('efiscalanio'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));
    const cmbMesTrimes = useRef();
    const radioMensual = useRef();
    const radioTrimestral = useRef();
    const radioAnual = useRef();
    const cmbMensual = useRef();
    const txtId4 = useRef();
    const txtDescrip4 = useRef();
    const check1 = useRef();
    const check2 = useRef();
    const check3 = useRef();
    const check4 = useRef();
    const check5 = useRef();
    const check6 = useRef();
    const check7 = useRef();
    const cmbCaja1 = useRef();
    const cmbCaja2 = useRef();
    const cmbMes = useRef();
    const cmbTrimi = useRef();
    const radioTodas = useRef();
    const radioTodas2 = useRef();
    const radioDesde = useRef();
    const radioDesde2 = useRef();
    const txtDesde = useRef();
    const txtHasta = useRef();
    const cmbTipoIngreso = useRef();
    const checkOtro = useRef();
    const txtTasa = useRef(); // Nuevo ref para el monto de la tasa

    const btnCancela = useRef();
    const [values, setValues] = useState({});
    const [itemSelect, setItemSelect] = useState(-1);
    const [operacion, setOperacion] = useState()
    const [select, setSelect] = useState(false);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [mostrar3, setMostrar3] = useState(false);
    const [tipoIngreso, setTipoIngreso] = useState()
    const [visible, setVisible] = useState('collapse');
    const [visible2, setVisible2] = useState('collapse');
    const [visible3, setVisible3] = useState('collapse');
    const [tipoOpcion, setTipoOpcion] = useState(3)
    const [disabledCaja, setDisabledCaja] = useState(false);
    const [otroSeleccionado, setOtroSeleccionado] = useState(false);

    const blanquear = () => {
        setVisible('collapse')
        setVisible2('collapse')
        if (operacion === 6) {
            setVisible3('collapse')
        }
        if (espiritu === 8 && operacion === 1) {
            setTipoOpcion(3)
        }
        setOtroSeleccionado(false);

        check1.current ? check1.current.checked = true : '';
        check3.current ? (check3.current.checked = true) : "";
        radioTodas2.current ? radioTodas2.current.checked = true : ''; // Resetear a Bolívares
        txtTasa.current?txtTasa.current.value = "" : ''; // Limpiar el campo de tasa
        setItemSelect("");
        setActivate(false);
        setOperacion(0)
    }

    const cancelar = () => {
        blanquear();
        props.onHideCancelar();
    }

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
        blanquear();
        props.onHideCancelar();
    }

    const onChange = (event) => {
        if (event.target.name === "rango") {
            if (event.target.value === "1") {
                setVisible({
                    ...visible,
                    porfecha: "collapse",
                    mensual: "collapse",
                    trimestral: "collapse",
                });
                setDisabledCaja(false);
                txtDesde.current.value = fechasistema;
                txtHasta.current.value = fechasistema;
            }

            if (event.target.value === "2") {
                setVisible({
                    ...visible,
                    porfecha: "visible",
                    mensual: "collapse",
                    trimestral: "collapse",
                });
                setDisabledCaja(false);
            }

            if (event.target.value === "3") {
                setVisible({
                    ...visible,
                    porfecha: "collapse",
                    mensual: "visible",
                    trimestral: "collapse",
                    caja: "collapse",
                });
                setDisabledCaja(true);
                radioTodas.current && (radioTodas.current.checked = true);
                radioDesde.current && (radioDesde.current.checked = false);
                cmbCaja1.current.value = "01";
                cmbCaja2.current.value = "20";
            }

            if (event.target.value === "4") {
                setVisible({
                    ...visible,
                    porfecha: "collapse",
                    mensual: "collapse",
                    trimestral: "visible",
                    caja: "collapse",
                });
                setDisabledCaja(true);
                radioTodas.current && (radioTodas.current.checked = true);
                radioDesde.current && (radioDesde.current.checked = false);
                cmbCaja1.current.value = "01";
                cmbCaja2.current.value = "20";
            }

            if (event.target.value === "5") {
                setVisible({
                    ...visible,
                    porfecha: "collapse",
                    mensual: "collapse",
                    trimestral: "collapse",
                    caja: "collapse",
                });
                setDisabledCaja(true);
                radioTodas.current && (radioTodas.current.checked = true);
                radioDesde.current && (radioDesde.current.checked = false);
                cmbCaja1.current.value = "01";
                cmbCaja2.current.value = "20";
            }
        }

        if (event.target.name === "caja") {
            if (event.target.value === "1") {
                setVisible({
                    ...visible,
                    caja: "collapse",
                });
                cmbCaja1.current.value = "01";
                cmbCaja2.current.value = "20";
            }

            if (event.target.value === "2") {
                setVisible({
                    ...visible,
                    caja: "visible",
                });
                cmbCaja1.current.value = "01";
                cmbCaja2.current.value = "20";
            }
        }

        if (event.target.name === "caja1") {
            if (parseInt(event.target.value) > parseInt(cmbCaja2.current.value)) {
                event.target.value = "01";
                setMensaje({
                    mostrar: true,
                    titulo: "Notificación",
                    texto: "la seleccion no debe ser mayor a la primera",
                    icono: "informacion",
                });
            }
        }

        if (event.target.name === "caja2") {
            if (parseInt(event.target.value) < parseInt(cmbCaja1.current.value)) {
                event.target.value = "10";
                setMensaje({
                    mostrar: true,
                    titulo: "Notificación",
                    texto: "la seleccion no debe ser menor a la primera",
                    icono: "informacion",
                });
            }
        }

        if (event.target.name === "caja3") {
            if (event.target.value === "1") {
                setVisible({
                    ...visible,
                    caja3: "collapse",
                });
            } else if (event.target.value === "2") {
                setVisible({
                    ...visible,
                    caja3: "visible",
                });
            }
        }

        if (event.target.name === "fechadesde") {
            let first = new Date(event.target.value);
            let second = new Date(txtHasta.current.value);

            if (first > second) {
                event.target.value = txtHasta.current.value;
                setMensaje({
                    mostrar: true,
                    titulo: "Notificación",
                    texto: "la fecha desde no debe ser mayor a la de hasta",
                    icono: "informacion",
                });
            }
        }

        if (event.target.name === "fechahasta") {
            let first = new Date(txtDesde.current.value);
            let second = new Date(event.target.value);

            if (first > second) {
                event.target.value = txtDesde.current.value;
                setMensaje({
                    mostrar: true,
                    titulo: "Notificación",
                    texto: "la fecha hasta no debe ser menor a la de desde",
                    icono: "informacion",
                });
            }
        }
    };

    const imprimir = () => {
        let reporte = '';
        let sql = '';
        let sql1 = '';
        let sql2 = '';
        let sql3 = '';
        let sql4 = '';
        let sql5 = '';
        let val4 = '';
        let val5 = '';
        let titulo = '';
        let titulo2 = '';
        let tiprep = ''
        let desde = ''
        let hasta = '';

        // Obtener año actual si no está definido
        const anioActu = efiscalanio || new Date().getFullYear();

        // Función para obtener días del mes
        const diasMes = (mes, anio) => {
            return new Date(anio, mes, 0).getDate();
        };

        if (operacion === 1) {
            // Validar si se seleccionó "Otro" pero no se eligió período
            if (otroSeleccionado && !check5.current?.checked && !check6.current?.checked && !check7.current?.checked) {
                setMensaje({
                    mostrar: true,
                    titulo: "Notificación",
                    texto: "Debe seleccionar un período (mensual, trimestral o anual)",
                    icono: "informacion",
                });
                return;
            }

            // Si es espíritu 8 o se seleccionó "Otro"
            if (espiritu === 8 || otroSeleccionado) {
                if (check5.current?.checked) {
                    // Mensual
                    let mes = cmbMes.current.value;
                    reporte = 'Tes_CajIngresoMes';
                    let MESDESCRIP = cmes(parseInt(mes));
                    let DIA = diasMes(parseInt(mes), anioActu);
                    let MES = mes;
                    let ANIO = anioActu.toString();
                    let CONDICION = "TRUE";

                    window.open(
                        `${op.reportes}/caja?reporte=${reporte}&CONDICION=${CONDICION}&MESDESCRIP=${MESDESCRIP}&DIA=${DIA}&MES=${MES}&ANIO=${ANIO}`,
                        "Planilla",
                        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
                    );
                    return;

                } else if (check6.current?.checked) {
                    // Trimestral
                    if (cmbTrimi.current.value === "0") {
                        reporte = 'Tes_CajIngresoTrimes1';
                    } else if (cmbTrimi.current.value === "1") {
                        reporte = 'Tes_CajIngresoTrimes2';
                    } else if (cmbTrimi.current.value === "2") {
                        reporte = 'Tes_CajIngresoTrimes3';
                    } else if (cmbTrimi.current.value === "3") {
                        reporte = 'Tes_CajIngresoTrimes4';
                    }

                    let ANIO = anioActu.toString();
                    let CONDICION = "TRUE";

                    // Parámetros de tipo de moneda
                    let tasa = radioDesde2.current?.checked ? 'true' : 'false';
                    let valorTasa = txtTasa.current.value.replace(/\./g, "").replace(",", ".") || '';
                    if (valorTasa === '' || parseInt(valorTasa) === 0) {
                        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debes ingresar una tasa', icono: 'informacion' })
                    return;
                    }
                    window.open(
                        `${op.reportes}/caja?reporte=${reporte}&CONDICION=${CONDICION}&ANIO=${ANIO}&TASA=${tasa}&FACTOR=${valorTasa}`,
                        "Planilla",
                        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
                    );
                    return;

                } else if (check7.current?.checked) {
                    // Anual
                    reporte = 'GraficoIngresos';
                    let ANIO = anioActu.toString();
                    let CONDICION = "TRUE";

                    window.open(
                        `${op.reportes}/caja?reporte=${reporte}&CONDICION=${CONDICION}&ANIO=${ANIO}`,
                        "Planilla",
                        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
                    );
                    return;
                }
            }

            // REPORTE GENERAL PARA OPERACIÓN 1
            reporte = 'Tes_CajIngreso';

            // Verificar si se seleccionó opción por rango de tiempo
            if (radioMensual.current?.checked) {
                // Mensual
                let fileName = "Tes_CajIngresoMes";
                let MESDESCRIP = cmes(parseInt(cmbMensual.current.value));
                let DIA = diasMes(parseInt(cmbMensual.current.value), anioActu);
                let MES = cmbMensual.current.value;
                let ANIO = anioActu.toString();
                let CONDICION = "TRUE";

                window.open(
                    `${op.reportes}/caja?reporte=${fileName}&CONDICION=${CONDICION}&MESDESCRIP=${MESDESCRIP}&DIA=${DIA}&MES=${MES}&ANIO=${ANIO}`,
                    "Planilla",
                    "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
                );
                return;

            } else if (radioTrimestral.current?.checked) {
                // Trimestral
                let fileName = "";
                if (cmbMesTrimes.current.value === "01") {
                    fileName = "Tes_CajIngresoTrimes1";
                } else if (cmbMesTrimes.current.value === "02") {
                    fileName = "Tes_CajIngresoTrimes2";
                } else if (cmbMesTrimes.current.value === "03") {
                    fileName = "Tes_CajIngresoTrimes3";
                } else if (cmbMesTrimes.current.value === "04") {
                    fileName = "Tes_CajIngresoTrimes4";
                }

                let ANIO = anioActu.toString();
                let CONDICION = "TRUE";

                // Parámetros de tipo de moneda
                let tasa = radioDesde2.current?.checked ? 'true' : 'false';
                let valorTasa = txtTasa.current?.value || '';
                if (valorTasa === '' || parseInt(valorTasa) === 0) {
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debes ingresar una tasa', icono: 'informacion' })
                }

                window.open(
                    `${op.reportes}/caja?reporte=${fileName}&CONDICION=${CONDICION}&ANIO=${ANIO}&TASA=${tasa}&FACTOR=${valorTasa}`,
                    "Planilla",
                    "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
                );
                return;

            } else if (radioAnual.current?.checked) {
                // Anual
                
                let fileName = "GraficoIngresos";
                let ANIO = anioActu.toString();
                let CONDICION = "TRUE";

                window.open(
                    `${op.reportes}/caja?reporte=${fileName}&CONDICION=${CONDICION}&ANIO=${ANIO}`,
                    "Planilla",
                    "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
                );
                return;
            }

            // Si no es por rango de tiempo, usar fechas normales
            if (visible2 === 'visible' && check4.current?.checked) {
                val4 = cmbCaja1.current.value;
                val5 = cmbCaja2.current.value;
                sql3 = val4 + " a la " + val5;
                sql = "NumCaja BETWEEN '" + val4 + "' AND '" + val5 + "'";
            } else {
                val4 = '01';
                val5 = '20'; // Asumiendo que tienes hasta 20 cajas
                sql3 = "Todas las cajas";
                sql = "TRUE";
            }

            // Manejo de fechas
            if (check1.current?.checked) {
                // Hoy
                desde = moment.utc().format('DD-MM-YYYY');
                hasta = moment.utc().format('DD-MM-YYYY');
                sql2 = "Resumen del Día " + desde;
            } else {
                // Por fecha específica
                desde = moment.utc(txtDesde.current.value).format('DD-MM-YYYY');
                hasta = moment.utc(txtHasta.current.value).format('DD-MM-YYYY');

                if (Date.parse(txtDesde.current.value) === Date.parse(txtHasta.current.value)) {
                    sql2 = "Resumen del Día " + desde;
                } else {
                    sql2 = "DESDE EL " + "'" + desde + "'" + " HASTA EL " + "'" + hasta + "'";
                }
            }
            const tasa = radioDesde2.current?.checked ? 'true' : 'false';
            let valorTasa = txtTasa.current?.value || valorDolar;

            window.open(
                `${op.reportes}/caja?reporte=${reporte}&CONDICION=${sql}&INIFECHA=${"'" + desde + "'"}&FINFECHA=${"'" + hasta + "'"}&TIT_RGO1=${sql2}&TIT_CRI1=${sql3}&isDolar=${tasa}&valorDolar=${parseFloat(valorTasa || 1).toFixed(2)}`,
                "Planilla",
                "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );

        } else if (operacion === 2) {
            reporte = 'Tes_CajIngresoBanco'

            if (visible2 === 'visible') {
                val4 = cmbCaja1.current.value;
                val5 = cmbCaja2.current.value;
            } else if (visible2 === 'visible') {
                val4 = '1';
                val5 = '1';
            }

            if (check1.current.checked) {
                desde = moment.utc().format('DD-MM-YYYY');
                hasta = moment.utc().format('DD-MM-YYYY');
                sql2 = "Resumen del Día " + desde;
            } else {
                desde = moment.utc(txtDesde.current.value).format('DD-MM-YYYY');
                hasta = moment.utc(txtHasta.current.value).format('DD-MM-YYYY');

                if (val4 === val5) {
                    sql3 = " " + val4;
                } else {
                    sql3 = val4 + " a la " + val5;
                }
                if (desde === hasta) {
                    sql2 = "Resumen del Día " + desde;
                } else {
                    sql2 = "DESDE EL" + " " + "'" + desde + "'" + " " + "HASTA EL" + " " + "'" + hasta + "'";
                }
            }

            if (check4.current.checked) {
                sql = "TRANS.NumCaja   Between " + "'" + val4 + "'" + " and " + "'" + val5 + "'";
            } else {
                sql = "true";
            }

            window.open(`${op.reportes + "/caja?"}reporte=${reporte}&CONDICION=${sql}&INIFECHA=${"'" + desde + "'"}&FINFECHA=${"'" + hasta + "'"}&TIT_RGO1=${sql2}&TIT_CRI1=${sql3}`,
                "Planilla",
                "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );

        } else if (operacion === 3 || operacion === 4) {
            if (operacion === 4) {
                if (espiritu === 15 || espiritu === 13) {
                    reporte = "Tes_CajIngresoPagoG";
                } else if (espiritu === 0) {
                    reporte = "Tes_CajIngresoPagoPaez";
                } else {
                    reporte = "Tes_CajIngresoPago";
                }
            } else {
                reporte = espiritu === 9 || espiritu === 12 ? 'Tes_CajIngresoTrAra' : 'Tes_CajIngresoTr';
            }

            if (visible2 === 'visible') {
                val4 = cmbCaja1.current.value;
                val5 = cmbCaja2.current.value;
            } else if (visible2 === 'visible') {
                val4 = '1';
                val5 = '1';
            }
            
            if (check1.current.checked) {
                desde = moment.utc().format('DD-MM-YYYY');
                hasta = moment.utc().format('DD-MM-YYYY');
                sql = "FechaPago Between" + "'" + desde + "'" + " AND " + "'" + hasta + "'";
                sql2 = "Transacciones del Día " + desde;
            }
            else {
                desde = moment.utc(txtDesde.current.value).format('DD-MM-YYYY');
                hasta = moment.utc(txtHasta.current.value).format('DD-MM-YYYY');

                sql += "FechaPago Between" + "'" + desde + "'" + " AND " + "'" + hasta + "'" ;
                sql2 = "DESDE EL" + " " + "'" + desde + "'" + " " + "HASTA EL" + " " + "'" + hasta + "'";
            }
            if (check4.current.checked) {
                sql += " AND TRAN.NumCaja Between" + "'" + val4 + "'" + "and" + "'" + val5 + "'"
                                sql3 = "Desde la Caja " + val4.trim() + " Hasta la " + val5.trim();

            } else {
                 sql += " AND TRAN.NumCaja Between '01'and '10'"
                                 sql3 = "Todas las Cajas";

            }
          
            window.open(`${op.reportes + "/caja?"}reporte=${reporte}&CONDICION=${sql}&TIT_RGO1=${sql2}&TIT_CRI1=${sql3}&FINFECHA=${"'" + hasta + "'"}&operacion=${'1'}&CAJA=${check4.current.checked && cmbCaja1.current.value === cmbCaja2.current.value ? '1' : '0'}`,
                "Planilla",
                "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );

        } else if (operacion === 5) {
            reporte = 'Tes_CajIngresoTr';

            if (visible2 === 'visible') {
                val4 = cmbCaja1.current.value;
                val5 = cmbCaja2.current.value;
            } else if (visible2 === 'visible') {
                val4 = '1';
                val5 = '1';
            }

            if (check1.current.checked) {
                desde = moment.utc().format('DD-MM-YYYY');
                hasta = moment.utc().format('DD-MM-YYYY');
                sql = "FechaPago Between " + "'" + desde + "'" + " AND " + "'" + hasta + "'" + "AND NumCaja Between '01'and '10'";
                sql2 = "Transacciones del Día " + desde;
                sql3 = "Transacciones Reversadas ";
            } else {
                desde = moment.utc(txtDesde.current.value).format('DD-MM-YYYY');
                hasta = moment.utc(txtHasta.current.value).format('DD-MM-YYYY');

                sql = "fechareverso Between" + "'" + desde + "'" + " AND " + "'" + hasta + "'" + "AND NumCaja Between" + "'" + val4 + "'" + "and" + "'" + val5 + "'";
                sql2 = "DESDE EL" + " " + "'" + desde + "'" + " " + "HASTA EL" + " " + "'" + hasta + "'";
                sql3 = "Transacciones Reversadas ";
            }

            window.open(`${op.reportes + "/caja?"}reporte=${reporte}&CONDICION=${sql}&TIT_RGO1=${sql2}&TIT_CRI1=${sql3}&FINFECHA=${"'" + hasta + "'"}&operacion=${'2'}&REVERSADO=${'1'}`,
                "Planilla",
                "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );

        } else if (operacion === 6) {
            if (cmbTipoIngreso.current.value === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación.', texto: 'Debe Selecionar un tipo de ingreso', icono: 'informacion' })
            } else {
                var select = document.getElementById("inputStatus")

                if (espiritu === 9 || espiritu === 12) {
                    if (select.options[select.selectedIndex].innerText === 'REPAROS ADMINISTRATIVOS POR IMPUESTOS MUNICIPALES') {
                        sql4 = 'true';
                        reporte = 'Tes_CajIngresoTrRepa';
                    } else {
                        sql4 = 'true';
                        reporte = 'Tes_CajIngresoTr';
                    }
                } else {
                    sql4 = 'true';
                    reporte = 'Tes_CajIngresoTr'
                }

                if (check1.current.checked) {
                    hasta = moment.utc().format('DD-MM-YYYY');
                    sql = "TRUE and ingr.idtipoingreso BETWEEN " + cmbTipoIngreso.current.value + " and " + cmbTipoIngreso.current.value;
                    sql2 = select.options[select.selectedIndex].innerText;
                    sql3 = " ";
                } else {
                    desde = moment.utc(txtDesde.current.value).format('DD-MM-YYYY');
                    hasta = moment.utc(txtHasta.current.value).format('DD-MM-YYYY');

                    sql = "FechaPago between '" + desde + "' and '" + hasta + "' and ingr.idtipoingreso BETWEEN " + cmbTipoIngreso.current.value + " and " + cmbTipoIngreso.current.value;
                    sql2 = "DESDE EL" + " " + "'" + desde + "'" + " " + "HASTA EL" + " " + "'" + hasta + "'";
                    sql3 = " ";
                }

                window.open(`${op.reportes + "/caja?"}reporte=${reporte}&CONDICION=${sql + " AND " + sql4}&TIT_RGO1=${sql2}&operacion=${'3'}&TIT_CRI1=${sql3}&FINFECHA=${"'" + hasta + "'"}`,
                    "Planilla",
                    "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
                );
            }
        }
    };

    const selectNaturaleza = (id) => {
        let endpoint = `${op.conexion}/api/contabilidadfis/selectnaturaleza?idefiscal=${id}&efiscalanio=${efiscalanio}`;
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status === 200) {
                setMensaje({ mostrar: true, titulo: 'Notificación.', texto: 'Operación exitosa', icono: 'informacion' })
            }
            setActivate(false);
        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        })
    }

    const cargarEjercicio = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
        let endpoint = `${op.conexion}/api/contabilidadfis/cargardesdeejercicio`;
        let body = {
            idefiscal: values[0].idefiscal,
            efiscal: idefiscal
        };


        axios.post(endpoint, body, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status === 200) {
                if (operacion === 1) {
                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'El plan de cuenta fúe cargado', icono: 'exito' })
                } else if (operacion === 3) {
                    selectNaturaleza(values[0].idefiscal)
                }
            }
            setActivate(false);
        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        })
    }

    const cargarVinculacion = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
        let endpoint = `${op.conexion}/api/contabilidadfis/seleccionarpuc?idefiscal=${values[0].idefiscal}`;
        axios.post(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status === 200) {
                setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Vinculación Cargada', icono: 'exito' })
            }
            setActivate(false);
        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        })
    }

    const datosRes = () => {
        let campos = '*';
        let nomtab = 'efiscal';
        let nomid = 'idefiscal';
        let nomid2 = 'idorganizacion';
        let id2 = idorganizacion;

        let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&id=${values[0].idefiscal}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id2=${id2}`;
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status === 200) {
                localStorage.setItem('efiscaldes', response.data[0].descriptor);
                localStorage.setItem('efiscalanio', response.data[0].anio);
                localStorage.setItem('idefiscal', values[0].idefiscal);
                localStorage.setItem('statuscat', response.data[0].statuscat);
                localStorage.setItem('statusorg', response.data[0].statusorg);
                localStorage.setItem('statuspresup', response.data[0].statuspresup);
                localStorage.setItem('statuspuc', response.data[0].statuspuc);
                setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Cambio realizado con exito', icono: 'exito' })
            }
            setActivate(false);
        }).catch(function (error) {
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
        })
    };

    const cargar = () => {
        if (operacion === 5) {
            cargarVinculacion()
        } else if (operacion === 18) {
            datosRes()
        } else if (operacion === 1 || operacion === 3) {
            cargarEjercicio()
        }
    }

    const seleccionarCuenta = (id) => {
        setMostrar3(false)
        let endpoint = `${op.conexion}/api/contabilidadfis/selectctaconta?id=${id}&idefiscal=${idefiscal}`;
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status === 200) {
                if (response.data !== '') {
                    txtId4.current.value = response.data.idcuentacontable;
                    txtDescrip4.current.value = response.data.descripcion;
                    setActivate(false);
                } else {
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe una Cuenta Contable con este Codigo.', icono: 'informacion' });
                    setActivate(false);
                }
            }
        }).catch(function (error) {
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
        })
    };

    const validarCuenta = (event) => {
        event.preventDefault();
        validaSoloNumero(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                seleccionarCuenta(event.target.value);
            } else {
                // txtDescripcion.current.value = '';
            }
        }
    };

    const selecionarRegistros = () => {
        let nomtab = 'tipoimpuesto';
        let nomid = 'idtipoingreso';
        let nomtab2 = 'tipoingreso';
        let nomid2 = 'idtipoingreso';

        let endpoint = `${op.conexion}/api/consulta/seleccionarregistros3?nomtab=${nomtab}&nomid=${nomid}&nomtab2=${nomtab2}&nomid2=${nomid2}`;
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status === 200) {
                setTipoIngreso(response.data)
            }
            setActivate(false);
        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        })
    }

    const cambio = (e) => {
        if (e.target.name === 'dia') {
            if (e.target.value === '0') { // Hoy
                setVisible('collapse');
                setOtroSeleccionado(false);
            } else if (e.target.value === '1') { // Por Fecha
                setVisible('visible');
                setOtroSeleccionado(false);
            } else if (e.target.value === '2') { // Otro
                setVisible('collapse');
                setOtroSeleccionado(true);
            }
        } else if (e.target.name === 'caja') {
            if (e.target.value === '0') {
                setVisible2('collapse')
            } else {
                setVisible2('visible')
            }
        } else if (e.target.name === 'mes') {
            setTipoOpcion(parseInt(e.target.value))
            if (e.target.value === '0' || e.target.value === '1') {
                setVisible3('visible')
            } else {
                setVisible3('collapse')
            }
        } else if (e.target.name === 'caja3') {
            if (e.target.value === '1') {
                setVisible({
                    ...visible,
                    caja3: "collapse",
                });
            } else if (e.target.value === '2') {
                setVisible({
                    ...visible,
                    caja3: "visible",
                });
            }
        }
    }

    const handleInputMontoChange = (event) => {
        validaMonto(event);
        if (event.which === 13 || typeof event.which === "undefined") {
            if (
                event.target.value === "" ||
                parseFloat(
                    event.target.value.trim().replace(/\./g, "").replace(",", ".")
                ) === 0.0
            ) {
                event.target.value = "0,00";
            }
            event.target.value = formatoMonto(event.target.value);
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === "0" && char2 !== ",") {
                event.target.value = event.target.value.substring(
                    1,
                    event.target.value.legth
                );
            }
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setSelect(parseInt(idefiscal));
                setOperacion(props.operacion)
                selecionarRegistros()
            }}
        >
            <Modal.Header className='azulGradiant'>
                <div className="fw-bold text-light">
                    {operacion === 1 ? 'Impresión General de Resumen de Caja.' :
                        operacion === 2 ? 'Impresión General de Resumen de Caja Por Caja.' :
                            operacion === 3 ? 'Impresión General de Transacciones Diarias.' :
                                operacion === 4 ? 'Impresión General de Transacciones Diarias Detalladas.' :
                                    operacion === 5 ? 'Impresión Transacciones Reversadas.' :
                                        operacion === 6 ? 'Impresión de Resumen de Transacción' : ''}
                </div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => mensaje.titulo === 'Exito.' ? cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
                <Dimmer active={activate} inverted>
                </Dimmer>
                <div className="col-md-12 row mx-auto">
                    <fieldset className="row col-md-12 border-azul rounded mx-auto">
                        <legend className="float-none m-0 w-auto">Rango de Fecha</legend>
                        <div className='col-md-6 mb-2 row mx-auto'>
                            <div className="form-check my-auto col">
                                <input className="form-check-input my-auto" value={0} type="radio" onChange={cambio} name='dia' id="flexRadioDefault1" ref={check1} defaultChecked />
                                <label className="form-check-label my-auto" for="flexRadioDefault1">
                                    Hoy
                                </label>
                            </div>
                            <div className="form-check my-auto col">
                                <input className="form-check-input my-auto" value={1} type="radio" onChange={cambio} name='dia' id="flexRadioDefault2" ref={check2} />
                                <label className="form-check-label my-auto" for="flexRadioDefault2">
                                    Por Fecha
                                </label>
                            </div>
                            {operacion === 1 ? <div className="form-check my-auto col">
                                <input className="form-check-input my-auto" value={2} type="radio" onChange={cambio} name='dia' id="flexRadioDefault3" ref={checkOtro} />
                                <label className="form-check-label my-auto" for="flexRadioDefault3">
                                    Otro
                                </label>
                            </div> : ''}
                        </div>
                        <div className='col-md-8 mx-auto row' style={{ visibility: visible }}>
                            <div className="input-group input-group-sm mb-3 col-md-6 mx-auto">
                                <span className="input-group-text" id="inputGroup-sizing-sm">Desde:</span>
                                <input type="date" className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={moment.utc(fechasistema).format('YYYY-MM-DD')} max={moment.utc(fechasistema).format('YYYY/MM/DD')} ref={txtDesde} />
                            </div>
                            <div className="input-group input-group-sm mb-3 col-md-6 mx-auto">
                                <span className="input-group-text" id="inputGroup-sizing-sm">Hasta:</span>
                                <input type="date" className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={moment.utc(fechasistema).format('YYYY-MM-DD')} max={moment.utc(fechasistema).format('YYYY/MM/DD')} ref={txtHasta} />
                            </div>
                        </div>

                        {/* Opciones de período (mes, trimestre, anual) - se muestran cuando se selecciona "Otro" o cuando espiritu === 8 */}
                        {(operacion === 1 && (espiritu === 8 || otroSeleccionado)) && (
                            <div className='col-md-12 row mx-auto'>
                                <div className='col-md-6 row mx-auto'>
                                    <div className="form-check my-auto col">
                                        <input className="form-check-input my-auto" value={0} type="radio" onChange={cambio} name='mes' id="flexRadioMensual" ref={check5} />
                                        <label className="form-check-label my-auto" for="flexRadioMensual">
                                            Mensual
                                        </label>
                                    </div>
                                    <div className="form-check my-auto col">
                                        <input className="form-check-input my-auto" value={1} type="radio" onChange={cambio} name='mes' id="flexRadioTrimestral" ref={check6} />
                                        <label className="form-check-label my-auto" for="flexRadioTrimestral">
                                            Trimestral
                                        </label>
                                    </div>
                                    <div className="form-check my-auto col">
                                        <input className="form-check-input my-auto" value={2} type="radio" onChange={cambio} name='mes' id="flexRadioAnual" ref={check7} />
                                        <label className="form-check-label my-auto" for="flexRadioAnual">
                                            Anual
                                        </label>
                                    </div>
                                </div>
                                <div className='col-md-6 row mx-auto' style={{ visibility: visible3 }}>
                                    {tipoOpcion === 0 ? (
                                        <div className="input-group input-group-sm col-md-12 mb-2">
                                            <select ref={cmbMes} className="form-select form-select-sm" id="inputStatus" name='municipio'>
                                                <option value="1">ENERO</option>
                                                <option value="2">FEBRERO</option>
                                                <option value="3">MARZO</option>
                                                <option value="4">ABRIL</option>
                                                <option value="5">MAYO</option>
                                                <option value="6">JUNIO</option>
                                                <option value="7">JULIO</option>
                                                <option value="8">AGOSTO</option>
                                                <option value="9">SEPTIEMBRE</option>
                                                <option value="10">OCTUBRE</option>
                                                <option value="11">NOVIEMBRE</option>
                                                <option value="12">DICIEMBRE</option>
                                            </select>
                                        </div>
                                    ) : tipoOpcion === 1 ? (
                                        <div className="input-group input-group-sm col-md-12 mb-2">
                                            <select ref={cmbTrimi} className="form-select form-select-sm" id="inputStatus" name='municipio'>
                                                <option value="0">1er Trimestre</option>
                                                <option value="1">2do Trimestre</option>
                                                <option value="2">3er Trimestre</option>
                                                <option value="3">4to Trimestre</option>
                                            </select>
                                        </div>
                                    ) : ''}
                                </div>
                            </div>
                        )}
                    </fieldset>

                    {operacion === 6 ? (
                        <div className="input-group py-1 input-group-sm col-sm-12 mt-3">
                            <label className="input-group-text" id="inputGroup-sizing-sm">Tipo impuesto:</label>
                            <select className="form-control form-control-sm" ref={cmbTipoIngreso} id="inputStatus" name='municipio'>
                                <option value="">Seleccione</option>
                                {tipoIngreso && tipoIngreso.map((item, index) => (
                                    <option key={item.descripcion} value={item.idtipoingreso}> {item.descripcion} </option>
                                ))}
                            </select>
                        </div>
                    ) : (
                        <>
                            <fieldset className="row border-azul rounded mx-auto">
                                <legend className="float-none m-0 w-auto">Numero de Caja</legend>
                                <div className='col-md-4 row mx-auto'>
                                    <div className="form-check my-auto col">
                                        <input className="form-check-input my-auto" value={0} type="radio" onChange={cambio} name='caja' id="flexRadioDefault9" ref={check3} defaultChecked />
                                        <label className="form-check-label my-auto" for="flexRadioDefault9">
                                            Todas
                                        </label>
                                    </div>
                                    <div className="form-check my-auto col">
                                        <input className="form-check-input my-auto" value={1} type="radio" onChange={cambio} name='caja' id="flexRadioDefault99" ref={check4} />
                                        <label className="form-check-label my-auto" for="flexRadioDefault99">
                                            Desde
                                        </label>
                                    </div>
                                </div>
                                <div className='col-md-8 row' style={{ visibility: visible2 }}>
                                    <div className="input-group input-group-sm col-md-6 mb-2">
                                        <label className="input-group-text" id="inputGroup-sizing-sm">Caja N°</label>
                                        <select ref={cmbCaja1} className="form-select form-select-sm" id="inputStatus" name='municipio'>
                                            <option value="01">01</option>
                                            <option value="02">02</option>
                                            <option value="03">03</option>
                                            <option value="04">04</option>
                                            <option value="05">05</option>
                                            <option value="06">06</option>
                                            <option value="07">07</option>
                                            <option value="08">08</option>
                                            <option value="09">09</option>
                                            <option value="10">10</option>
                                        </select>
                                    </div>
                                    <div className="input-group input-group-sm col-md-6 mb-2">
                                        <label className="input-group-text" id="inputGroup-sizing-sm">Caja N°</label>
                                        <select ref={cmbCaja2} className="form-select form-select-sm" id="inputStatus" name='municipio'>
                                            <option value="01">01</option>
                                            <option value="02">02</option>
                                            <option value="03">03</option>
                                            <option value="04">04</option>
                                            <option value="05">05</option>
                                            <option value="06">06</option>
                                            <option value="07">07</option>
                                            <option value="08">08</option>
                                            <option value="09">09</option>
                                            <option value="10">10</option>
                                        </select>
                                    </div>
                                </div>
                            </fieldset>

                            {/* Nuevo campo de Tipo de Moneda */}
                            {operacion === 1 ? <fieldset className="row col-sm-12 mx-auto border rounded mt-3">
                                <legend className="float-none w-auto" style={{ fontSize: "15px", fontWeight: "bold" }}>
                                    Tipo de Moneda
                                </legend>
                                <div className="row col-md-7">
                                    <div className="col d-flex">
                                        <input
                                            ref={radioTodas2}
                                            disabled={disabledCaja}
                                            defaultChecked={true}
                                            style={{
                                                width: "1.25rem",
                                                height: "1.25rem",
                                                outline: "none",
                                            }}
                                            onChange={() => setEsDolar(false)}
                                            
                                            value="1"
                                            type="radio"
                                            id="caja3_1"
                                            name="caja3"
                                        />
                                        <label className="form-check-label px-1" htmlFor="caja3_1">
                                            Bolivares (Bs.)
                                        </label>
                                    </div>
                                    <div className="col-md-6 d-flex">
                                        <input
                                            ref={radioDesde2}
                                            disabled={disabledCaja}
                                            style={{
                                                width: "1.25rem",
                                                height: "1.25rem",
                                                outline: "none",
                                            }}
                                            onChange={() => setEsDolar(true)}
                                            value="2"
                                            type="radio"
                                            id="caja3_2"
                                            name="caja3"
                                        />
                                        <label className="form-check-label px-1" htmlFor="caja3_2">
                                            Por Tasa de Cambio
                                        </label>
                                    </div>
                                </div>
                                {esDolar && (
                                     <div className="row col-md-6 px-0">
                                     <div className="input-group input-group-sm mb-3">
                                         <span className="input-group-text" id="inputGroup-sizing-sm">Monto de la Tasa:</span>
                                         <input
                                             ref={txtTasa} onBlur={handleInputMontoChange}
                                             defaultValue={valorDolar}
                                             onKeyUp={handleInputMontoChange}
                                             type="text"
                                             className="form-control text-end"
                                             aria-label="Sizing example input"
                                             aria-describedby="inputGroup-sizing-sm"
                                         />
                                     </div>
                                 </div>
                                )}
                               
                            </fieldset> : ''}
                        </>
                    )}

                    <CatalogoContable
                        llamado={1}
                        show={mostrar3}
                        onHideCancela={() => { setMostrar3(false) }}
                        onHideAcepta={seleccionarCuenta}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-primary rounded-pill" style={{ margin: "5px" }} onClick={imprimir}><i className="fas fa-print"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default ImpModalCaja;